import React, { Component } from 'react';
import { Map } from '@esri/react-arcgis';
import Basemap from './Basemap';
import Point from './Point';
import ChartTest from './ChartTest';
import { Modal, Button } from 'react-bootstrap';
import './Home.css';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            sites: [], selectedSiteID: 0, selectedSiteName: "", currentSite: {}, hidden: true, mobile: false }

        fetch('api/Site/GetSites')
            .then(response => response.json())
            .then(data => {
                this.setState({ sites: data });
            });
        this.callbackFunction = this.callbackFunction.bind(this);
        this.toggleHidden = this.toggleHidden.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }
    callbackFunction(siteID, siteName, currentSite) {
        this.setState({ selectedSiteID: siteID, selectedSiteName: siteName, currentSite: currentSite });
    }

    toggleHidden() {
        this.setState({
            hidden: !this.state.hidden
        });
    }
    handleClose() {
        this.setState({
            hidden: true
        });
    }
    componentDidMount() {
        var mobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        if (mobile) {
            this.toggleHidden();
        }
    }
    render() {
        
        var content = this.state.sites.length > 0 ? <Map style={{ height: '100%' }} viewProperties={{ center: [-78.492, 38.031944], zoom: 13 }}><Basemap /><Point onChange={this.callbackFunction} sites={this.state.sites} /></Map> : <p>Loading</p>;
        return (
            <div className="row">
                <Modal show={!this.state.hidden} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Site Count</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>You appear to viewing on a mobile device. For best performance, please rotate your screen.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
                <div className="col-sm-7" id="MapView" style={{ padding: 0 }}>
                    {content}
                </div>
                <div className="col-sm-5" style={{ height: '92vh', overflowY: 'scroll' }}>
                    {this.state.selectedSiteID !== 0 ? <ChartTest site={this.state.currentSite} /> : <p className="lead" style={{ textAlign: 'center', padding: 20, border: '1px solid grey', borderRadius: '10px' }}>Please select a site on the map to see the count data</p>}
                
                </div>
                
            </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js